export default {"src":"/_next/static/media/logo.94cfbdc0.svg","height":46,"width":150};